import $ from 'jquery';
import {checkCardStatus, setCard} from '../api/api';
import checkKey from '../../scripts/util/event/checkKey';
import setHeight from '../../scripts/util/dom/setHeight';

export default class Gift {
	constructor(cb) {
		this.selectors = {
			el: '.js-gift-card',
			wrapper: '.js-gift-wrapper',
			form: '.js-gift-form',
			field: '.js-field',
			button: '.js-gift-button',
			open: '.js-gift-open',
			balance: '.js-card-balance',
			close: '.js-gift-close',
			cardNumber: '.js-card-number',
			cardMinus: '.js-card-minus'
		};

		this.classes = {
			hidden: {
				form: 'gift-card__body_state_hidden',
				el: 'gift-card_state_hidden'
			},
			open: 'gift-card_state_open',
			visible: {
				cross: 'checkout__remove_state_visible'
			},
			error: 'field_state_error'
		};

		this.$document = $(document);

		this.$el = $(this.selectors.el);
		this.$wrapper = $(this.selectors.wrapper);
		this.$form = this.$el.find(this.selectors.form);
		this.$field = this.$el.find(this.selectors.field);
		this.$button = this.$el.find(this.selectors.button);
		this.$open = $(this.selectors.open);
		this.$close = $(this.selectors.close);
		this.$balance = $(this.selectors.balance);
		this.$cardNumber = $(this.selectors.cardNumber);
		this.$cardMinus = $(this.selectors.cardMinus);

		this.callback = cb;
	}

	sendData(form, data) {
		const url = form.data('action');
		const type = form.data('method');

		return $.when($.ajax( {type, url, data} ));
	}

	open() {
		this.$el.addClass(this.classes.open);
		this.$close.addClass(this.classes.visible.cross);
		setHeight(this.$el, this.$wrapper);
	}

	close() {
		this.$el.removeClass(this.classes.open);
		this.$close.removeClass(this.classes.visible.cross);
		this.$el.css('height', 0);
	}

	toggleForm(current, target) {
		const hiddenClass = this.classes.hidden.form;
		current.addClass(hiddenClass);
		target.removeClass(hiddenClass);
	}

	collectData(form) {
		const $fields = form.find('input');
		const result = {};

		$fields.each(item => {
			result[$fields.eq(item).attr('name')] = $fields.eq(item).val();
		});

		return result;
	}

	onSubmit = e => {
		const $target = $(e.currentTarget);
		const current = $target.data('order');
		const $field = $target.find(this.$field);
		const $next = current === this.$form.length ? this.$form.filter(`[data-order=1]`) : this.$form.filter(`[data-order=${current + 1}]`);
		const data = this.collectData($target);
		let send = 0;

		if (current === 1) {
			send = checkCardStatus(data);
		} else if (current === 2) {
			send = setCard(data);
		} else {
			this.onSuccess($target, $next);
		}

		if (current !== 3) {
			send.then(
				resp => this.onSuccess($target, $next, current, resp),
				() => this.onFailure($field)
			);
		}
	}

	onSuccess(form, next, current, data) {
		this.toggleForm(form, next);
		if (!data) {
			this.callback(0);
		}

		if (current === 1) {
			this.$balance.eq(0).text(data.balance + ' ₽');
			this.$cardNumber.eq(0).text(data.number);
		} else if (current === 2) {
			this.$balance.eq(1).text(data.balance + ' ₽');
			this.$cardNumber.eq(1).text(data.number);
			this.$cardMinus.eq(0).text(data.minus);
			this.callback(data.minus);
		}
		setHeight(this.$el, this.$wrapper);
	}

	onFailure(field) {
		field.addClass(this.classes.error);
	}

	onKeypress(e) {
		if (checkKey(e)) {
			this.close();
		}
	}

	onResize() {
		const hasClass = this.$el.hasClass(this.classes.open);
		if (hasClass) {
			setHeight(this.$el, this.$wrapper);
		}
	}

	toggleActive = e => {
		const checkbox = e.currentTarget;
		const isChecked = $(checkbox).is(':checked');
		const $input = $('.field__value_unit_rub input');

		if (!isChecked) {
			this.$button.addClass('button_disabled');
			$input.prop('disabled', true);
		} else {
			this.$button.removeClass('button_disabled');
			$input.prop('disabled', false);
		}
	};

	render() {
		this.$form.on('valid', this.onSubmit);
		this.$open.on('click', () => this.open());
		this.$close.on('click', () => this.close());
		this.$document.on('keydown', e => this.onKeypress(e));
		window.onresize = () => this.onResize();
		$('.js-gift-card .js-checkbox-input').on('change', this.toggleActive);
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/gift-card/gift-card.js
 **/